module.exports = __webpack_public_path__ + "img/folder-yellow.0daab8e5.svg";